import {jwtDecode} from "jwt-decode";

// Check if token is expired
export const isTokenValid = (token) => {
  try {
    const { exp } = jwtDecode(token);
    return Date.now() < exp * 1000;
  } catch {
    return false;
  }
};

// Get remaining time (ms) before token expires
export const getTokenRemainingTime = (token) => {
  try {
    const { exp } = jwtDecode(token);
    return exp * 1000 - Date.now();
  } catch {
    return 0;
  }
};
